import { proxy_api_call } from '@/WebHandler/proxy_api_call'
import { useState, useEffect } from 'react'
import Select from 'react-select'
import AllIcons from 'constant/AllIcons'

const SelectBox = ({
  current_data,
  update_data,
  title,
  note,
  dropdown_items,
  is_fetch_data,
  extra_data,
}) => {
  const [dropdown_items_list, setDropdownItemsList] = useState(dropdown_items)
  const [isLoading, setISLoading] = useState(false)

  useEffect(() => {
    if (is_fetch_data) {
      setISLoading(true)
      proxy_api_call({
        method: 'GET',
        path: extra_data.path,

        onSuccess: (data) => {
          setISLoading(false)
          setDropdownItemsList((prev) => [
            ...prev,
            ...data?.map((item) => ({
              label: extra_data?.label_key ? item?.[extra_data.label_key] : item.title,
              value: extra_data?.value_ke ? item?.[extra_data.value_key] : `${item.id}`,
            })),
          ])
        },
        onError: (err) => {
          setISLoading(false)
        },
      })
    }
  }, [])

  return (
    <div className="space-y-2  w-full ">
      {title && (
        <label
          className="  text-sm font-medium mb-1 flex items-center  gap-2 justify-start"
          htmlFor="web_primary_font"
        >
          {title}
          {isLoading && AllIcons.loading_icon}
        </label>
      )}
      <Select
        className="w-full"
        id="tradly-react-select"
        options={dropdown_items_list}
        value={
          isLoading
            ? {}
            : {
                label: dropdown_items_list?.filter((it) => it.value == current_data)[0]?.label,
                value: current_data,
              }
        }
        onChange={(e) => {
          update_data(e.value)
        }}
      />

      {note && <p className="text-xs mt-2 italic">{note}</p>}
    </div>
  )
}

export default SelectBox
